import React from 'react';
import { Container } from 'react-bootstrap';

const Banner = () => {
    const bannerStartDateTime =
        process.env.REACT_APP_GLOBAL_BANNER_START_DATETIME;
    const bannerEndDateTime = process.env.REACT_APP_GLOBAL_BANNER_END_DATETIME;

    if (bannerStartDateTime && new Date() < new Date(bannerStartDateTime)) {
        return null;
    }
    if (bannerEndDateTime && new Date() > new Date(bannerEndDateTime)) {
        return null;
    }

    const bannerMainContent =
        process.env.REACT_APP_GLOBAL_BANNER_MAIN_CONTENT ?? '';
    const bannerMainLinks =
        process.env.REACT_APP_GLOBAL_BANNER_MAIN_LINKS ?? '';
    const bannerSubContent =
        process.env.REACT_APP_GLOBAL_BANNER_SUB_CONTENT ?? '';
    const bannerSubLinks = process.env.REACT_APP_GLOBAL_BANNER_SUB_LINKS ?? '';

    if (!bannerMainContent) {
        return null;
    }

    return (
        <div id="gs-htg-banner">
            <Container
                className="bg-banner-db text-white text-center p-3"
                fluid
            >
                <h4 className="m-0">
                    {getContentNodes(bannerMainContent, bannerMainLinks)}
                </h4>
                {bannerSubContent && (
                    <h6 className="mt-2">
                        {getContentNodes(bannerSubContent, bannerSubLinks)}
                    </h6>
                )}
            </Container>
        </div>
    );
};

const getContentNodes = (template, links) => {
    const linkElements = links
        .split(',')
        .map((chunk) => chunk.trim())
        .map((chunk, idx) => {
            const [label, url] = chunk.split('|');
            return (
                <a
                    key={idx}
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {label}
                </a>
            );
        });

    const parts = template.split(/(\{\{link\d+\}\})/g);
    const nodes = parts.map((part) => {
        const m = part.match(/\{\{link(\d+)\}\}/);
        return m ? linkElements[parseInt(m[1], 10)] : part;
    });

    return nodes;
};

export default Banner;
